// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import './CurrentMatches.scss';
import CircleLoader from '../../../Util/CircleLoader/CircleLoader';
import Request from '../../../../api/Request';
import { observable } from 'mobx';
import { Link } from 'react-router-dom';

@inject('userStore')
@observer class CurrentMatches extends Component<any, any> {
	
	@observable matches: any;

	@observable loading: boolean = false;

	@observable empty: boolean = false;

	constructor(props: any) {
		super(props);

		this.toggleMatches = this.toggleMatches.bind(this);
	}

	fetch() {
		if (this.props.question) {
			Request.get('/questions/' + this.props.question.id + '/matches?orderBy[createdAt]=DESC&limit=5', {}).then((response) => {
				if(!response.status) {
					this.matches = response;
				}
			});
		}
	}

	toggleMatches(e: any) {
		if (this.matches) {
			this.matches = null;
			this.empty = false;
		} else {
			this.loading = true;
			this.empty = false;
			Request.get('/questions/' + this.props.question.id + '/matches?orderBy[createdAt]=DESC&limit=5', {}).then((response) => {
				this.loading = false;
				if(!response.status) {
					this.matches = response;
					if (this.matches.length === 0) {
						this.empty = true;
					}
				}
			});
		}
	}

	render() {
		if (this.props.question) {
			return (
				<div className="current-matches">			
					<h4 onClick={this.toggleMatches}>active matches</h4>
					<div className="current-matches-body">
						{this.matches && this.matches.length > 0 ? 
							<ul>
								{this.matches.map((match: any) => {
									return (
										<li>
											<Link to={'/match/' + match.id}><i className="icon-eye"></i> <span>{match.participants[0].username} <b>vs</b> {match.participants[1].username}</span></Link>
										</li>
									);
								})}
							</ul>
						:
							<span className={this.empty ? "no-matches" : ""}>
								{this.empty ? 
									"no matches yet."
									:
									null
								}
							</span>
						}
						{this.loading ? 
							<CircleLoader size={20} color="#fff"/>
							:
							null
						}
					</div>
				</div>
			)
		} else {
			return null;
		}
	}
}

export default CurrentMatches;

